export default {"src":"/_next/static/media/DOC.e500477a.svg","height":18,"width":18};